import React, { useContext } from 'react'

import copy from 'copy-to-clipboard'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { TitleContext } from '@providers/TitleProvider'
import { useDialogStore } from '@stores/dialog.store'
import GoogleTagManager from '@utils/gtm/google-tag-manager'

import 'react-toastify/dist/ReactToastify.css'

interface Props {
  onClick: () => void
}

const AddToMenu: React.FC<Props> = ({ onClick }) => {
  const { t } = useTranslation()
  const openDialog = useDialogStore((s) => s.openDialog)
  const { title } = useContext(TitleContext)

  const copyLink = (): void => {
    copy(window.location.href)
    toast(<div className="text-center font-sans">{t('messages.linkCopied')}</div>)

    GoogleTagManager.trackShare('copy_link', 'title', title.uuid)
    onClick()
  }

  const embed = (): void => {
    openDialog('embed_title')

    GoogleTagManager.trackShare('embed', 'title', title.uuid)
    onClick()
  }

  return (
    <div className="text-sm p-1.5">
      {title.embed_url && ( //only show the embed option if this score has an embed url
        <button type="button" className="block cursor-pointer mb-2" onClick={embed}>
          {t('action.embedScore')}
        </button>
      )}
      <button type="button" className="block cursor-pointer mb-2" onClick={copyLink}>
        {t('action.copyLinkToScore')}
      </button>
    </div>
  )
}

export default AddToMenu
